<template>
    <div>
        <dx-grid
            url="foodDistributionAccountInfo"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
            :expandedOptions="{
                enabled: true,
                allowExpandingAll: true,
                template: 'food-distribution-family-details',
            }"
        ></dx-grid>
        <v-dialog v-model="importCrossStreetDialog" max-width="500">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Import Cross Street</v-card-title
                >
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="importCrossStreetDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="importCrossStreet(true)"
                    >
                        update all
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="importCrossStreet()"
                    >
                        update missing
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="importDialog" max-width="450">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Import Family Info</v-card-title
                >
                <v-layout row>
                    <v-btn
                        @click="exportToExcel"
                        color="success"
                        outline
                        :loading="isExporting"
                        >Export
                        <v-icon right dark>mdi-cloud-download</v-icon></v-btn
                    >
                    <v-btn
                        small
                        outline
                        class="mr-2 ml-2"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Import
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="pt-2 mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept=".xlsx, .xls"
                    @change="onFilePicked($event)"
                />
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeImportDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="importFile()"
                    >
                        import
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="updateFamilyDialog" max-width="650">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Family</v-card-title
                >
                <v-layout row>
                    <div class="mb-3" style="width: 50%">
                        <div>{{ rowClicked.name }}</div>
                        <div>{{ rowClicked.busAddress1 }}</div>
                        <div class="mt-2">
                            <span class="font-weight-medium pr-2"
                                >Large Boxes:</span
                            >
                            {{ rowClicked.largeBoxes }}
                        </div>
                        <div>
                            <span class="font-weight-medium pr-2"
                                >Small Boxes:</span
                            >
                            {{ rowClicked.smallBoxes }}
                        </div>
                    </div>
                    <div
                        class="mb-3 pa-2"
                        style="width: 50%; border: #4caf50 2px solid;"
                        v-if="rowClicked.accountChanges"
                    >
                        <div class="headline">Account Changes</div>
                        <div class="mt-2">
                            <span class="font-weight-medium pr-2 width-200"
                                >Change Type:</span
                            >
                            {{ rowClicked.accountChanges.change }}
                        </div>
                        <div>
                            <span class="font-weight-medium pr-2 width-200"
                                >Current Address:</span
                            >
                            {{ rowClicked.accountChanges.currentAddress }}
                        </div>
                        <div v-if="rowClicked.accountChanges.previousAddress">
                            <span class="font-weight-medium pr-2 width-200"
                                >Previous Address:</span
                            >
                            {{ rowClicked.accountChanges.previousAddress }}
                        </div>
                    </div>
                </v-layout>
                <div style="overflow-y: auto; height: 550px">
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Route Number"
                        v-model="rowClicked.routeNumber"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Route Sort"
                        v-model="rowClicked.routeSort"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Label Batch"
                        v-model="rowClicked.labelBatch"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Box Note"
                        v-model="rowClicked.boxNote"
                    ></v-text-field>
                    <div style="border: 2px solid #4caf50" class="pa-2">
                        <div class="title mb-2">Notification Numbers</div>
                        <v-layout row>
                            <v-text-field
                                class="mr-2 mt-0"
                                label="Alert #"
                                v-model="rowClicked.sendAlertsTo"
                                ref="sendAlertsTo"
                                :rules="[rules.phoneNumber]"
                            ></v-text-field>
                            <v-select
                                class="mt-0"
                                hide-details
                                :items="['CALL', 'TEXT']"
                                label="Alert Type"
                                v-model="rowClicked.sendAlertsType"
                            ></v-select>
                        </v-layout>
                        <v-layout row>
                            <v-text-field
                                class="mr-2 mt-0"
                                label="Alert #"
                                v-model="rowClicked.alertNumber2"
                                ref="alertNumber2"
                                :rules="[rules.phoneNumber]"
                            ></v-text-field>
                            <v-select
                                class="mt-0"
                                hide-details
                                :items="['CALL', 'TEXT']"
                                label="Alert Type"
                                v-model="rowClicked.alertType2"
                            ></v-select>
                        </v-layout>
                        <v-layout row>
                            <v-text-field
                                class="mr-2 mt-0"
                                label="Alert #"
                                v-model="rowClicked.alertNumber3"
                                ref="alertNumber3"
                                :rules="[rules.phoneNumber]"
                            ></v-text-field>
                            <v-select
                                class="mt-0"
                                hide-details
                                :items="['CALL', 'TEXT']"
                                label="Alert Type"
                                v-model="rowClicked.alertType3"
                            ></v-select>
                        </v-layout>
                    </div>
                    <v-radio-group
                        v-model="rowClicked.enrolled"
                        row
                        class="mb-2 mt-3"
                        hide-details
                    >
                        <div class="width-200">Enrolled</div>
                        <v-radio
                            class="pr-2"
                            label="0"
                            value="0"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pr-2"
                            label="1"
                            value="1"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class=""
                            label="2"
                            value="2"
                            color="success"
                        ></v-radio>
                    </v-radio-group>

                    <v-radio-group
                        v-model="rowClicked.enrolledForSummer"
                        row
                        class="mb-4 mt-2"
                        hide-details
                    >
                        <div class="width-200">Enrolled For Summer</div>
                        <v-radio
                            class="pr-2"
                            label="0"
                            value="0"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pr-2"
                            label="1"
                            value="1"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class=""
                            label="2"
                            value="2"
                            color="success"
                        ></v-radio>
                    </v-radio-group>

                    <v-btn
                        v-if="
                            !rowClicked.siblings || !rowClicked.siblings.length
                        "
                        color="success"
                        @click="addSibling(rowClicked.siblings)"
                        >Add Sibling</v-btn
                    >

                    <div v-for="(sibling, index) in rowClicked.siblings">
                        <v-layout row>
                            <!-- <div>{{ sibling.nameRecordingURL }}</div> -->
                            <audio
                                v-if="sibling.nameRecordingURL"
                                style="height: 25px; width: 300px;"
                                controls
                                class="mt-2 mr-2"
                                :src="sibling.nameRecordingURL"
                            ></audio>
                            <v-text-field
                                style="width: 150px;"
                                class="mr-2 mt-0 pt-0"
                                label="Name"
                                v-model="sibling.name"
                            ></v-text-field>
                            <v-text-field
                                class="mt-0 pt-0 mr-2"
                                :rules="[rules.required]"
                                label="Age"
                                style="width: 50px;"
                                type="number"
                                ref="age"
                                v-model="sibling.age"
                            ></v-text-field>

                            <v-menu
                                v-model="sibling.datePickerMenu"
                                :close-on-content-click="false"
                                full-width
                                class="pt-0 mt-0"
                                max-width="290"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="sibling.dob"
                                        class="pt-0 mt-0"
                                        label="Date"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="sibling.dob"
                                    @change="sibling.datePickerMenu = false"
                                ></v-date-picker>
                            </v-menu>

                            <v-btn
                                class="mt-0"
                                @click="addSibling(rowClicked.siblings)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn
                                class="mt-0"
                                @click="
                                    removeSibling(rowClicked.siblings, index)
                                "
                                flat
                                icon
                                color="#f55a4e"
                            >
                                <v-icon>mdi-minus-circle-outline</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-divider
                            class="pt-3 pb-1"
                            v-if="index + 1 < rowClicked.siblings.length"
                            :key="index"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateFamilyDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveFamily()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            color="info"
            top
            right
            :timeout="snackbarTimeout"
            v-model="crossStreetUpdate.processingMessagesSnackbar"
            dark
        >
            <v-layout column>
                <div class="headline mb-2">
                    {{ crossStreetUpdate.processingMessages }}
                </div>
            </v-layout>
            <v-icon
                size="16"
                @click="crossStreetUpdate.processingMessagesSnackbar = false"
            >
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </div></template
>
<script>
import moment from "moment";
import { formatPhoneNumber, toISOLocal } from "../../utils/helpers.js";
import XLSX from "xlsx";
import Pusher from "pusher-js";

export default {
    data: () => ({
        title: "Families",
        snackbarTimeout: 0,

        columns: [
            {
                label: "Family ID",
                field: "familyID",
                link: "FoodDistributionFamilyView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Search",
                field: "nameSearch",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Total Kids",
                field: "totalKids",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Boys",
                field: "boys",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Girls",
                field: "girls",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Additional Siblings",
                field: "additionalSiblings",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Summer Weeks",
                field: "dcWeeks",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Small Boxes",
                field: "smallBoxes",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Large Boxes",
                field: "largeBoxes",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Enrolled",
                field: "enrolled",
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Enrolled For Summer",
                field: "enrolledForSummer",
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Override Reason",
                field: "overrideReason",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Address 1",
                field: "busAddress1",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Address 2",
                field: "busAddress2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Street",
                field: "busStreet",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus House",
                field: "busHouse",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Apt",
                field: "busApt",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus State",
                field: "busState",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert To",
                field: "sendAlertsTo",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Type",
                field: "sendAlertsType",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Number 2",
                field: "alertNumber2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Type 2",
                field: "alertType2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Number 3",
                field: "alertNumber3",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Type 3",
                field: "alertType3",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Street",
                field: "busStreet",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street Side",
                field: "streetSide",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Enrolled Date",
                field: "enrolledDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Route Number",
                field: "routeNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Route Sort",
                field: "routeSort",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Label Batch",
                field: "labelBatch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cross Street 1",
                field: "crossStreet1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cross Street 2",
                field: "crossStreet2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Note",
                field: "boxNote",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        url: "",
        user: "",
        processing: false,
        action: "",

        importDialog: false,
        uploading: false,
        isExporting: false,
        files: [],
        rowClicked: "",
        updateFamilyDialog: false,
        importCrossStreetDialog: false,

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        crossStreetUpdate: {
            requestID: "",
            processingMessagesSnackbar: false,
            processingMessages: "",
            totalProcessingMessages: "",
            totalCount: "",
            missingCrossStreetTotalCount: "",
        },
    }),
    created() {
        this.user = this.$store.state.authentication.user;

        this.actions.push({
            text: "Import Family Info",
            action: this.openImportDialog,
        });

        this.actions.push({
            text: "Import Cross Street",
            action: this.openImportCrossStreet,
            name: "importCrossStreet",
        });

        this.loadTotalCount();
        this.loadMissingCrossStreetTotalCount();
    },
    mounted() {
        this.subscribeToPusher();
    },
    beforeDestroy() {
        this.pusher.unsubscribe("food-distribution");
    },
    methods: {
        subscribeToPusher() {
            this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
                cluster: "mt1",
            });

            var channel = this.pusher.subscribe("food-distribution");

            this.pusher.connection.bind("error", function(err) {
                console.log(err);
            });

            channel.bind("cross-street-update", (message) => {
                this.updateProcessingMessage(message);
            });
        },
        updateProcessingMessage(message) {
            if (message.requestID != this.crossStreetUpdate.requestID) return;

            if (
                message.index == this.crossStreetUpdate.totalProcessingMessages
            ) {
                this.crossStreetUpdate.processingMessages = "";
                this.crossStreetUpdate.processingMessagesSnackbar = false;
            } else {
                this.crossStreetUpdate.processingMessages =
                    message.index +
                    "/" +
                    this.crossStreetUpdate.totalProcessingMessages +
                    " " +
                    message.text;
            }
        },
        async loadTotalCount() {
            const response = await this.$http.get(
                "odata/foodDistributionAccountInfo?$apply=aggregate($count as count)"
            );

            this.crossStreetUpdate.totalCount = response.value[0].count;
        },
        async loadMissingCrossStreetTotalCount() {
            const response = await this.$http.get(
                "odata/foodDistributionAccountInfo?$apply=filter(crossStreet1 eq null)/aggregate($count as count)"
            );

            this.crossStreetUpdate.missingCrossStreetTotalCount =
                response.value[0].count;
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value.substring(1));
        },
        async onRowClicked(row) {
            // this.rowClicked = JSON.parse(JSON.stringify(row));

            // const siblings = await this.$http.get(
            //     "api/FoodDistributionAccountInfo/GetSiblings?callUUID=" +
            //         this.rowClicked.callUUID
            // );

            // const accountChanges = await this.$http.get(
            //     "api/FoodDistributionAccountInfo/getAccountChanges?accountID=" +
            //         this.rowClicked.familyID
            // );

            // this.rowClicked.siblings =
            //     siblings.map((sibling) => {
            //         sibling.dob = new Date(moment(sibling.dob))
            //             .toISOString()
            //             .substr(0, 10);

            //         sibling.datePickerMenu = false;

            //         return sibling;
            //     }) || [];

            // this.rowClicked.accountChanges = accountChanges;
            // this.rowClicked.enrolled =
            //     this.rowClicked.enrolled.toString() || "0";
            // this.rowClicked.enrolledForSummer = this.rowClicked
            //     .enrolledForSummer
            //     ? this.rowClicked.enrolledForSummer.toString()
            //     : "0";
            // this.rowClicked.isEnrolled = this.rowClicked.enrolled == 1;

            // this.updateFamilyDialog = true;
            this.$router.push({
                name: "FoodDistributionFamilyView",
                params: { id: row.familyID },
            });
        },
        openImportCrossStreet() {
            this.importCrossStreetDialog = true;
        },
        async importCrossStreet(updateAll = false) {
            try {
                this.processing = true;

                this.crossStreetUpdate.requestID = Math.floor(
                    Math.random() * 10000000
                );

                this.crossStreetUpdate.totalProcessingMessages = updateAll
                    ? this.crossStreetUpdate.totalCount
                    : this.crossStreetUpdate.missingCrossStreetTotalCount;

                this.processingMessages =
                    "0/" + this.crossStreetUpdate.totalProcessingMessages;

                this.crossStreetUpdate.processingMessagesSnackbar = true;

                const response = await this.$http.post(
                    "api/foodDistributionAccountInfo/importCrossStreet?requestID=" +
                        this.crossStreetUpdate.requestID +
                        "&updateAll=" +
                        updateAll
                );

                this.processing = false;

                this.crossStreetUpdate.processingMessagesSnackbar = false;

                this.$notify({
                    group: "notification",
                    text: "Cross Street Updated",
                    type: "success",
                });

                this.importCrossStreetDialog = false;

                this.loadTotalCount();
                this.loadMissingCrossStreetTotalCount();

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        addSibling(siblings) {
            if (!siblings) {
                siblings = [];
            }
            siblings.push({
                id: 0,
                familyID: this.rowClicked.familyID,
                nameRecordingURL: "",
                age: "",
                callUUID: this.rowClicked.callUUID,
                name: "",
            });

            this.$forceUpdate();
        },
        removeSibling(siblings, index) {
            siblings.splice(index, 1);
            this.$forceUpdate();
        },
        getSiblings() {
            return this.rowClicked.siblings;
        },
        fixPhoneNumber(value) {
            if (!value) return "";

            let number = value.trim().replace(/\D/g, "");

            number = number.length == 10 ? "1" + number : number;

            return number;
        },
        validateNotificationSettings() {
            const alert1 =
                this.fixPhoneNumber(this.rowClicked.sendAlertsTo) +
                "|" +
                this.rowClicked.sendAlertsType;
            const alert2 =
                this.fixPhoneNumber(this.rowClicked.alertNumber2) +
                "|" +
                this.rowClicked.alertType2;
            const alert3 =
                this.fixPhoneNumber(this.rowClicked.alertNumber3) +
                "|" +
                this.rowClicked.alertType3;

            if (
                this.fixPhoneNumber(this.rowClicked.sendAlertsTo) &&
                (alert1 == alert2 || alert1 == alert3)
            )
                return false;
            if (
                this.fixPhoneNumber(this.rowClicked.alertNumber2) &&
                (alert2 == alert1 || alert2 == alert3)
            )
                return false;
            if (
                this.fixPhoneNumber(this.rowClicked.alertNumber3) &&
                (alert3 == alert2 || alert3 == alert1)
            )
                return false;

            return true;
        },
        async saveFamily() {
            if (
                !this.$refs.sendAlertsTo.validate(true) ||
                !this.$refs.alertNumber2.validate(true) ||
                !this.$refs.alertNumber3.validate(true)
            )
                return;

            if (!this.validateNotificationSettings()) {
                this.$notify({
                    group: "notification",
                    text: "Please remove duplicate phone numbers",
                    type: "error",
                });

                return;
            }

            try {
                await this.$http.post(
                    "api/foodDistributionAccountInfo/updateFamily",
                    {
                        familyID: this.rowClicked.familyID,
                        siblings: this.rowClicked.siblings,
                        routeNumber: this.rowClicked.routeNumber,
                        routeSort: this.rowClicked.routeSort,
                        labelBatch: this.rowClicked.labelBatch,
                        boxNote: this.rowClicked.boxNote,
                        enrolled: +this.rowClicked.enrolled,
                        enrolledForSummer: +this.rowClicked.enrolledForSummer,
                        user: this.user,
                        sendAlertsTo: this.fixPhoneNumber(
                            this.rowClicked.sendAlertsTo
                        ),
                        sendAlertsType:
                            this.rowClicked.sendAlertsType == "TEXT" ? 2 : 1,
                        alertNumber2: this.fixPhoneNumber(
                            this.rowClicked.alertNumber2
                        ),
                        alertType2:
                            this.rowClicked.alertType2 == "TEXT" ? 2 : 1,
                        alertNumber3: this.fixPhoneNumber(
                            this.rowClicked.alertNumber3
                        ),
                        alertType3:
                            this.rowClicked.alertType3 == "TEXT" ? 2 : 1,
                    }
                );

                this.$notify({
                    group: "notification",
                    text: "Family Saved",
                    type: "success",
                });

                this.updateFamilyDialog = false;
                this.$refs.grid.reloadGrid();
            } catch (e) {}
        },
        exportFields() {
            let fields = {};

            this.columns.forEach((column) => {
                fields[column.label] = column.field;
            });

            return fields;
        },
        async exportToExcel() {
            try {
                const response = await this.$http({
                    url: "api/foodDistributionAccountInfo/exportToExcel",
                    method: "GET",
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Families.xlsx");
                document.body.appendChild(link);
                link.click();
            } catch (e) {
            } finally {
            }
        },
        async printLabels() {
            try {
                const response = await this.$http({
                    url: "api/foodDistributionAccountInfo/GetLabels",
                    method: "GET",
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "BoxesLabels.pdf");
                document.body.appendChild(link);
                link.click();
            } catch (e) {}
        },
        openImportDialog() {
            this.importDialog = true;
        },
        pickFile() {
            this.$refs.files.click();
        },
        onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        closeImportDialog() {
            this.importDialog = false;
            this.files = [];
            this.$refs.files.value = "";
        },
        async importFile() {
            this.processing = true;

            try {
                var formData = new FormData();

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/foodDistributionAccountInfo/ImportInfo?user=" +
                        this.user,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.$notify({
                    group: "notification",
                    text: response.saved + " Families Saved",
                    type: "success",
                });

                this.processing = false;
                this.importDialog = false;
                this.files = [];
                this.$refs.files.value = "";

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
